
import Vue from 'vue'
import ImageLightbox from './ImageLightbox.vue'
import LazyBackgroundImage from './LazyBackgroundImage.vue'

export default {
    data() {
        return {

        };
    },

    props: {
      images: {
        type: Array,
        default: function() {
          return [];
        },
      },
      lightbox: {
        type: Boolean,
        default: true,
      },
    },

    computed: {

    },

    watch: {

    },

    methods: {
      didSelectOpenImageGallery: function(startIndex = 0) {
        if(!this.lightbox) return;

        var ComponentClass = Vue.extend(ImageLightbox),
            instance = new ComponentClass({
                propsData: { imageData: this.images, startIndex: startIndex },
            })
            instance.$mount();

            document.body.appendChild(instance.$el);
      },
    },

    components: {
      LazyBackgroundImage,
    },

    created() {

    },
    mounted() {
      //var self = this;
    },
};




// WEBPACK FOOTER //
// ./scripts/vue/ImageGallery.vue